import { Box, Button, Checkbox, FormControlLabel, FormGroup, FormLabel } from "@mui/material";
import { useFormik } from "formik";

const DemoForm = ({ onApply }) => {
  const initialValues = {
    status: []
  }


  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values) => {
      onApply(values);  // Pass form values correctly
    }
  });

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    const newStatus = checked
      ? [...formik.values.status, value] // Add value if checked
      : formik.values.status.filter((item) => item !== value); // Remove value if unchecked

    formik.setFieldValue("status", newStatus);
  };

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <FormGroup>
          <FormLabel>Status</FormLabel>
          <FormControlLabel
            label="Active"
            control={
              <Checkbox
                name="status"
                value="1"
                checked={formik.values.status.includes("1")}
                onChange={handleCheckboxChange}
              />
            }
          />
          <FormControlLabel
            label="In-active"
            control={
              <Checkbox
                name="status"
                value="0"
                checked={formik.values.status.includes("0")}
                onChange={handleCheckboxChange}
              />
            }
          />
        </FormGroup>
        <Button type="submit">Apply</Button>
      </form>
    </Box>
  );
}

export default DemoForm;